<template>
  <div :class="'snail_fifth_layout ' + language ">
    <div class="filter"></div>
    <!-- 活动标题 -->
    <div v-wechat-title="languageUseMap[this.language].webTitle"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-snail' v-show="count < 100">
        <!-- <div @touchmove.prevent class='preloading preloading-snail'> -->
        <div class="logo"></div>
        <div class="poster"></div>
        <div class="clouds"></div>
        <div class="loading_bg">
          <div class="line_bar"></div>
          <div class="loading">
            <div class="loading_line"></div>
          </div>

          <div class="change_text">{{ count }}%</div>
        </div>
      </div>
    </transition>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
      :duration="{ enter: 1000 }">
      <div class="prevent" v-show="overlayClass" />
    </transition>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' :gameName="gameName" :downloadUrl="downloadUrl"
      :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS="true" noAuthLogin>
    </Login>
    <overseasLogin :visible="overseasVisible" @init="getUserInfo" @updateVisible=updateVisible></overseasLogin>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell'
      @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <Header v-if='count >= 100' :config='headerConfig' :isShowInfo='true' :isOnline='1' @reInit="reInit"
      :newUserInfo="newUserInfo" :language="language" @onLogin="ridLogin">
    </Header>
    <div :class="'super_punch_clock_page ' + (isSafari ? 'safari' : '')" v-show="count >= 100">
      <!-- <div :class="'super_punch_clock_page ' + (isSafari ? 'safari' : '')"> -->
      <div class="index " ref="mobile" id="mobile">
        <div :class="isPlayMusic ? 'music_btn  memu_btn ' : 'music_btn  memu_btn  memu_btn_active'" @click="musicEvent">
        </div>
        <a id="share_btn" href="javascript:;" class="share_btn memu_btn" @click="onCopyShare('#share_btn')"
          :data-clipboard-text='languageUseMap[this.language].desc + shareLink'></a>
        <div class="rule_btn memu_btn" @click="openPopup('ruleShow')"></div>
        <a class="benefit memu_btn" @click="openPopup('benefit')">
          <img class="swiper-lazy" :src="trialConfig.translations.benefit" alt="详情">
        </a>

        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
          :duration="{ enter: 1000 }">
          <div class="tv_show" v-if="stepShow === 0">
            <div class="tv">
              <div class="eye"
                :style="{ 'transform': 'scale(' + viewportRatio * 0.3 + ')', 'bottom': 220 * viewportRatio * viewportRatio + 'px' }">
                <div class="eye-ani"></div>
              </div>
              <div class="tv_mask"></div>
            </div>
            <div class="slogan">
              <img class="swiper-lazy" :src="trialConfig.translations.slogan" alt="详情">
            </div>
            <div class="woman" :style="{ 'transform': 'scale(' + viewportRatio + ')', 'bottom': womanBottom }">
              <div class="chunji"></div>
            </div>
            <div class="bar">
              <div class="btn_1" @click="watchTv">
                <img class="swiper-lazy" :src="trialConfig.translations.watch_btn" alt="详情">
              </div>
            </div>
            <div class="captions">
              <div class="fifth-snail-tvShow-captions-text" v-html="trialConfig.translations.captions"></div>
            </div>
          </div>
        </transition>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
          :duration="{ enter: 1000 }">
          <div class="trial" v-if="stepShow >= 1">
            <div class="slogan"></div>
            <div class="eye" :style="{ 'transform': 'translate(-50%, -35%)  scale(' + viewportRatio * 0.7 + ')' }">
              <div class="eye-ani">
              </div>
            </div>
            <div class="table">
            </div>
            <div class="frog"></div>
            <div class="lamp"></div>
            <div class="leftclould"></div>
            <div :class="activity.race === 2 ? 'snail brid' : 'snail'">
              <div class="light"></div>
            </div>
            <div class="chat" @click="handClick">
              <div class="hand" :style="{ 'transform': 'scale(' + viewportRatio + ')' }">
              </div>
              <chatModule class="chat" :msglist="dynamicsConfig.msglist" :step="stepShow" :mini="mini"
                :info="clickInfo" />
            </div>
          </div>
        </transition>

      </div>
      <div class="foot-page">
        <component :is="currentFooterComponent" :gameName="gameName"></component>
      </div>
    </div>
    <!-- 分享列表 -->
    <div class="share_wrap popup_wrap" v-if="shareShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box1">
          <img class="swiper-lazy bg-img" :src="shareBg" alt="详情">
          <div class="share_wrap_main">
            <div class="head">
              <img class="swiper-lazy wanted-img"
                :src="activity.race === 2 ? trialConfig.translations.brid : trialConfig.translations.snail" alt="详情">
              <div class="stamp">
                <img class="swiper-lazy wanted-img" :src="trialConfig.translations.stamp" alt="详情">
              </div>
            </div>
            <div class="name">{{ userinfo.role_name }}</div>
            <div class="share-text age">{{ dynamicsConfig.dynamicsContentDetails.age }}</div>
            <div class="share-text address">{{ userinfo.server_name }}</div>
            <div class="share-text dna">{{ dynamicsConfig.dynamicsContentDetails.dna }}</div>
            <div class="share-text form_step">{{ dynamicsConfig.dynamicsContentDetails.form_step }}</div>
            <div class="wanted">
              <img class="swiper-lazy wanted-img" :src="dynamicsConfig.dynamicsContentDetails.wanted.img" alt="详情">
              <div class="wanted-text1">{{ dynamicsConfig.dynamicsContentDetails.wanted.content }}</div>
            </div>
            <div class="event" v-if="activity.total_score > 100000">
              <img class="swiper-lazy wanted-img" :src="eventBg" alt="详情">
              <div class="event-text" v-for="item in criminalData">{{ item.content }}</div>
            </div>
            <div class="event" v-else>
              <img class="swiper-lazy wanted-img" :src="eventBg" alt="详情">
            </div>
            <div class="btn_items">
              <div class="again btn_item" @click.stop="anginClick">
                <img class="swiper-lazy bg-img" :src="trialConfig.translations.again" alt="详情">
              </div>
              <a id="link_btn" href="javascript:;" class="share btn_item" @click.stop="onShare('#link_btn')"
                :data-clipboard-text='languageUseMap[this.language].desc + shareLink'>
                <img class="swiper-lazy bg-img" :src="trialConfig.translations.share" alt="详情"></a>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 证据列表 -->
    <div class="criminal_wrap popup_wrap" v-if="criminalShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box" v-show="criminalShow">
          <div class="criminal_box" :style="{ left: criminal === 0 ? '146%' : criminal === 1 ? '51%' : '-45%' }">
            <div class="criminal">
              <div class="criminal_items" v-if="criminalData2.length > 0">
                <div class="criminal_item" v-for="criminalItem in criminalData2">
                  <img class="swiper-lazy criminal_item-img" :src="criminalItem.titleImg" alt="详情">
                  <div class="text">{{ criminalItem.content }}</div>
                  <div class="testimony">
                    <img class="swiper-lazy testimony-img " :src="criminalItem.msgImg" alt="详情">
                  </div>
                </div>
              </div>
              <img class="swiper-lazy evidence-img " :src="trialConfig.translations.criminal" alt="详情">
            </div>
            <div class="criminal">
              <div class="criminal_items" v-if="criminalData1.length > 0">
                <div class="criminal_item" v-for="criminalItem in criminalData1">
                  <img class="swiper-lazy criminal_item-img" :src="criminalItem.titleImg" alt="详情">
                  <div class="text">{{ criminalItem.content }}</div>
                  <div class="testimony">
                    <img class="swiper-lazy testimony-img " :src="criminalItem.msgImg" alt="详情">
                  </div>
                </div>
              </div>
              <img class="swiper-lazy evidence-img " :src="trialConfig.translations.criminal" alt="详情">
            </div>
            <div class="criminal">
              <div class="criminal_items">
                <div class="criminal_item" v-for="criminalItem in criminalData">
                  <img class="swiper-lazy criminal_item-img" :src="criminalItem.titleImg" alt="详情">
                  <div class="text">{{ criminalItem.content }}</div>
                  <div class="testimony">
                    <img class="swiper-lazy testimony-img " :src="criminalItem.msgImg" alt="详情">
                  </div>
                </div>
              </div>
              <img class="swiper-lazy evidence-img " :src="trialConfig.translations.criminal" alt="详情">
            </div>
          </div>
          <div class="hand" @click.stop="criminalClick" :style="{ 'transform': 'scale(' + viewportRatio + ')' }"></div>
        </div>

      </transition>
    </div>
    <!-- 口供记录 -->
    <div class="evidence_wrap popup_wrap" v-if="evidenceShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box" v-show="evidenceShow">
          <div class="evidence_box"
            :style="{ left: evidence === 0 ? '196%' : evidence === 1 ? '99%' : evidence === 2 ? '2%' : '-94%' }">
            <div class="evidence1">
              <img class="swiper-lazy evidence-img " :src="trialConfig.translations.race1" alt="详情">
            </div>
            <div class="evidence1">
              <img class="swiper-lazy evidence-img " :src="trialConfig.translations.race2" alt="详情">
            </div>
            <div class="evidence1">
              <img class="swiper-lazy evidence-img " :src="trialConfig.translations.evidence" alt="详情">
              <div class="evidence_item">
                <div class="text">{{ dynamicsConfig.dynamicsContentDetails.horus_eye }}</div>
                <div class="text">{{ dynamicsConfig.dynamicsContentDetails.profane_eye }}</div>
                <img class="swiper-lazy" :src="trialConfig.translations.evidence4" alt="详情">
              </div>
              <div class="evidence_item">
                <div class="text">{{ dynamicsConfig.dynamicsContentDetails.sacrifice_total }}</div>
                <img class="swiper-lazy" :src="trialConfig.translations.evidence5" alt="详情">
              </div>
              <div class="evidence_item">
                <div class="text">{{ dynamicsConfig.dynamicsContentDetails.boss_challenge }}</div>
                <div class="text">{{ dynamicsConfig.dynamicsContentDetails.boss_full_win }}</div>
                <img class="swiper-lazy" :src="trialConfig.translations.evidence6" alt="详情">
              </div>
            </div>
            <div class="evidence">
              <img class="swiper-lazy evidence-img " :src="trialConfig.translations.evidence" alt="详情">
              <div class="evidence_item">
                <div class="text">{{ dynamicsConfig.dynamicsContentDetails.money_total }}</div>
                <div class="text">{{ dynamicsConfig.dynamicsContentDetails.gem_total }}</div>
                <img class="swiper-lazy" :src="trialConfig.translations.evidence1" alt="详情">
              </div>
              <div class="evidence_item">
                <div class="text">{{ dynamicsConfig.dynamicsContentDetails.lottery_count }}</div>
                <div class="text">{{ activity.lottery_count * 300 }}</div>
                <div class="text">{{ activity.max_lottery_eucal[0] }} {{
                  "(" + formatDate(activity.max_lottery_eucal[1]) + ")" }}
                </div>
                <div class="text">{{ activity.min_lottery_eucal[0] }} {{
                  "(" + formatDate(activity.min_lottery_eucal[1]) + ")" }}
                </div>
                <img class="swiper-lazy" :src="trialConfig.translations.evidence2" alt="详情">
              </div>
              <div class="evidence_item">
                <div class="text">{{ dynamicsConfig.dynamicsContentDetails.gene_variation_consume }}</div>
                <div class="text">{{ dynamicsConfig.dynamicsContentDetails.real_organ_count }}</div>
                <img class="swiper-lazy" :src="trialConfig.translations.evidence3" alt="详情">
              </div>
            </div>
          </div>
          <div class="hand" @click.stop="evidenceClick" :style="{ 'transform': 'scale(' + viewportRatio + ')' }"></div>
        </div>

      </transition>
    </div>

    <!-- 对话弹窗 -->
    <div class="dialogue_wrap popup_wrap" v-if="dialogueShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">

          <div class="earth_talks">
            <div class="multi-line">
              <div class="typing-line" v-for="(item) in questionInfo.question">"{{ item }}"</div>
            </div>
          </div>
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
            :duration="{ enter: 1000 }">
            <div class="answer" v-show="answerShow">
              <div class="answer_item" @click.stop="answerClick(item)" v-for="(item) in questionInfo.answers"
                :key="item.display">
                <img class="swiper-lazy evidence-img " :src="item.content" alt="详情">
              </div>
            </div>
          </transition>

        </div>
      </transition>
    </div>

    <!-- 核对信息弹窗 -->
    <div class="envelope_wrap popup_wrap" v-if="envelopeShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box" @click="fingerClick">
          <div :class="'details'" :style="{ left: !envelopeShow_min ? '150%' : '52%' }">
            <div class="line"></div>
            <img class="swiper-lazy" 
                :src="activity.race === 2 ? trialConfig.translations.brid_details : trialConfig.translations.details"alt="详情">
            <div class="union">
              <div class="title">{{ dynamicsConfig.dynamicsContentDetails.unionTitle }}</div>
              <div class="text">{{ dynamicsConfig.dynamicsContentDetails.unionText }}</div>
              <img class="swiper-lazy" :src="trialConfig.translations.union" alt="详情">
            </div>
            <div class="dna">
              <div class="text">{{ dynamicsConfig.dynamicsContentDetails.dna }}</div>
              <img class="swiper-lazy" :src="trialConfig.translations.dna" alt="详情">
            </div>
            <div class="device">
              <div class="text">{{ activity.best_equip_name }} {{ activity.best_equip_step > 0 ?
                '+' + activity.best_equip_step : '' }}</div>
              <img class="swiper-lazy" :src="trialConfig.translations.device" alt="详情">
            </div>
            <div class="native">
              <div class="text">{{ dynamicsConfig.dynamicsContentDetails.form_step || 0 }}</div>
              <img class="swiper-lazy"
                :src="activity.race === 2 ? trialConfig.translations.brid_native : trialConfig.translations.native"
                alt="详情">
            </div>
            <div class="self">
              <div class="self_text name">{{ userinfo.role_name }}</div>
              <div class="self_text age">{{ dynamicsConfig.dynamicsContentDetails.age }}</div>
              <div class="self_text address">{{ userinfo.server_name }}</div>
              <div class="money">{{ dynamicsConfig.dynamicsContentDetails.score }}</div>
              <div class="text">{{ dynamicsConfig.dynamicsContentDetails.surpass }}</div>
              <img class="swiper-lazy"
                :src="activity.race === 2 ? trialConfig.translations.brid_self : trialConfig.translations.self"
                alt="详情">
            </div>
            <div class="finger">
              <div class="red" v-show="fingerShow" />
            </div>
          </div>
          <div :class="'open_box'" :style="{ left: !envelopeShow_min ? '52%' : '-150%' }">
            <img class="swiper-lazy" :src="trialConfig.translations.envelope" alt="详情">
            <div class="open_btn" @click.stop="openEnvelope">
              <img class="swiper-lazy" :src="trialConfig.translations.open_btn" alt="详情">
            </div>
          </div>

        </div>
      </transition>
    </div>
    <!-- 动画弹窗 -->
    <div class="animation_wrap popup_wrap" v-show="animationShow">

      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box_brid" :style="{ 'transform': 'translate(-50%, -50%)  scale(' + viewportRatio + ')' }"
          v-if="activity.race === 2"></div>
        <div class="detail_box_snail" :style="{ 'transform': 'translate(-50%, -50%)  scale(' + viewportRatio + ')' }"
          v-else></div>
      </transition>
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box_hammer" :style="{ 'transform': 'translate(-50%, -50%)  scale(' + viewportRatio + ')' }">
        </div>
      </transition>
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box_frog" :style="{ 'transform': 'translate(-50%, -50%)  scale(' + viewportRatio + ')' }">
        </div>
      </transition>
    </div>
    <!-- 动画弹窗 -->
    <div class="animation_last_wrap popup_wrap" v-show="animationLastShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box_hammer" :style="{ 'transform': 'translate(-50%, -50%)  scale(' + viewportRatio + ')' }">
        </div>
      </transition>
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box_eye">
          <div class="show-eye">
          </div>
          <div class="show-msg">
            <img class="swiper-lazy" :src="trialConfig.translations.last_msg" alt="详情">
          </div>
        </div>
      </transition>
    </div>
    <!-- <div class="share_wrap popup_wrap"> -->
    <div class="share_wrap popup_wrap" v-if="shareImgLoad" @click="closePopup('shareImgLoadShow')"
      :style="{ 'opacity': shareImgLoadShow ? '1' : '0', 'z-index': shareImgLoadShow ? '999' : '-1' }">
      <img class="swiper-lazy share-img" :src="shareImg" alt="详情">
      <div class="detail_box1" ref="imageDom">
        <img class="swiper-lazy bg-img" :src="shareBg" alt="详情">
        <div class="share_wrap_main">

          <div class="head">
            <img class="swiper-lazy wanted-img"
              :src="activity.race === 2 ? trialConfig.translations.brid : trialConfig.translations.snail" alt="详情">
            <div class="stamp">
              <img class="swiper-lazy wanted-img" :src="trialConfig.translations.stamp" alt="详情">
            </div>
          </div>
          <div class="name">{{ userinfo.role_name }}</div>
          <div class="share-text age">{{ dynamicsConfig.dynamicsContentDetails.age }}</div>
          <div class="share-text address">{{ userinfo.server_name }}</div>
          <div class="share-text dna">{{ dynamicsConfig.dynamicsContentDetails.dna }}</div>
          <div class="share-text form_step">{{ dynamicsConfig.dynamicsContentDetails.form_step }}</div>

          <div class="wanted">
            <img class="swiper-lazy wanted-img" :src="dynamicsConfig.dynamicsContentDetails.wanted.img" alt="详情">
            <div class="wanted-text1">{{ dynamicsConfig.dynamicsContentDetails.wanted.content }}</div>
          </div>
          <div class="code" v-if="language === 'zh-cn'">
            <img class="swiper-lazy event-code" :src="trialConfig.translations.code" alt="详情">
          </div>
          <div class="event" v-if="activity.total_score > 100000">
            <img class="swiper-lazy wanted-img" :src="eventBg" alt="详情">
            <div class="event-text" v-for="item in criminalData">{{ item.content }}</div>
          </div>
          <div class="event" v-else>
            <img class="swiper-lazy wanted-img" :src="eventBg" alt="详情">
          </div>
        </div>
      </div>
      <div class="save_text">
        <img class="swiper-lazy" :src="trialConfig.translations.save_text" alt="详情">
      </div>
    </div>
    <!-- 信息列表 -->
    <div class="code_wrap popup_wrap" v-if="ruleShow" @click="closePopup('ruleShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="trialConfig.translations.rule" alt="详情">
          </div>
        </div>
      </transition>
    </div>
    <!-- 奖励列表 -->
    <div class="reward_wrap popup_wrap" v-if="rewardShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="reward_title">
            <img class="swiper-lazy" :src="trialConfig.translations.reward_title" alt="详情">
          </div>
          <div class="reward_items">
            <div class="reward_item">
              <img class="swiper-lazy" :src="trialConfig.translations.reward1" alt="详情">
            </div>
            <div class="reward_item">
              <img class="swiper-lazy" :src="trialConfig.translations.reward2" alt="详情">
            </div>
            <div class="reward_item">
              <img class="swiper-lazy" :src="trialConfig.translations.reward3" alt="详情">
            </div>
          </div>
          <div class="reward_click" @click="reward_click"></div>

        </div>
      </transition>
    </div>
    <!-- 微信下载 -->
    <div class="wx_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="closePopup('wxLoadShow')"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="closePopup('wxLoadShow')"></div>
    </div>

    <!-- 预加载图片 -->
    <img style="display: none" src="../../../../assets/images/active/snail/fifth/mo/chunji.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/snail/fifth/mo/frog_ani.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/snail/fifth/mo/hammer_ani.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/snail/fifth/mo/eye_ani.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/snail/fifth/mo/snail_ani.png" alt="">
    <img style="display: none" src="../../../../assets/images/active/snail/fifth/mo/brid_ani.png" alt="">

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Footer from "@/components/Footer";
import { headerConfig } from '../headerConfig';
import { TrialConfig, dynamicsConfig } from '../TrialConfig';
import { onGetInitDataAPI, reward, secretFreeLoginApi } from '../api';
import { getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';
import 'swiper/dist/css/swiper.css'
import Clipboard from 'clipboard';
import { generateQRCode, generateCanvasImage } from '@/utils/share';
import { Indicator } from 'mint-ui';
import Header from '../Header/index.vue';
import chatModule from '../components/chatModule.vue';
import { StringNullableChain } from 'lodash';
import "../../../../assets/js/howler";

import overseasLogin from '../components/Login/index.vue';
import Footer_tw from '../components/Footer/index.vue';
import { transform } from 'lodash';
// import eruda from 'eruda';

export default {
  name: 'fifthReport',
  components: {
    chatModule,
    Header,
    Login,
    Os,
    Footer,
    Footer_tw,
    overseasLogin
  },
  data() {
    return {
      headerConfig: null,
      gameName: 'snail',
      is_access_token: '',
      downloadUrl: 'http://snail.qingcigame.com/official/',
      taptapUrl: 'https://tap.cn/tm3lTYBt?channel=rep-rep_nlo5ha7ptsr',
      loginTypes: ["sms", "password", "channel"],
      preloadingShow: true,
      preventShow: false,
      logger: null,
      isWechatBrowser: false, // 是否为微信浏览器
      isSafari: false,
      shareShow: false,
      animationShow: false,
      animationLastShow: false,
      animationClass: '',
      envelopeShow: false,
      envelopeShow_min: false,
      dialogueShow: false,
      answerShow: false,
      fingerShow: false,
      shareImg: null,
      shareBg: null,
      eventBg: null,
      videoShow: false,
      click_item_active: 1,
      messageImg: '',
      isPC: false,
      selectInfo: {},
      isExpanded: false,
      codeShow: false,
      messageShow: false,
      wxLoadShow: false,
      isUserInfo: false,
      shareLink: '',
      userinfo: {},
      observer: null,
      loopInt: null,
      rewardSum: 0,
      activity: { race: 1 },
      isRewardStart: false,
      ruleShow: false,
      sureShow: false,
      copyShow: false,
      count: 10,
      newUserInfo: {},
      isWechatApp: false,
      qrcodeSrc: null,
      overlayClass: false,
      trialConfig: null,
      dynamicsConfig: null,
      evidence: 0, //证据步骤
      stepShow: 0,// 当前步骤
      msgActive: true,
      questionInfo: {
        question: [''],
        answers: [
          {
            content: '',
            display: ''
          }
        ]
      },
      evidenceShow: false,
      isEvidence: false,
      criminal: 0,
      isCriminal: false,
      criminalShow: false,
      languageUseMap: {
        "zh-cn": {
          "URLS": "https://h5.qingcigame.com/",
          "Footers": "Footer",
          "gameName": "snail",
          "name": '最强蜗牛',
          "webTitle": '五周年：年度审判!',
          "router": '5thReport',
          "desc": '盘点蜗犯的罪，领取改造的礼'
        },
        "zh-tw": {
          "URLS": "https://h5.snell.com.tw/",
          "Footers": "Footer_tw",
          "gameName": "snail_tw",
          "name": '最强蜗牛_港澳台',
          "webTitle": '五週年：年度審判!',
          "router": '5thReport',
          "desc": '盤點蝸犯的罪，領取改造的禮！'
        },
        "ja-jp": {
          "URLS": "https://h5-sg.qcplay.com/",
          "Footers": "Footer",
          "gameName": "snail_tw",
          "name": '最强蜗牛',
          "webTitle": '五周年：年度审判!',
          "router": '5thReport',
          "desc": '盘点蜗犯的罪，领取改造的礼'
        },
        "en-us": {
          "URLS": "https://h5-sg.qcplay.com/",
          "Footers": "Footer_tw",
          "gameName": "snail_tw",
          "name": '最强蜗牛',
          "webTitle": '五周年：年度审判!',
          "router": '5thReport',
          "desc": '盘点蜗犯的罪，领取改造的礼'
        }
      },
      URLS: {
        'ja-jp': 'https://h5-sg.qcplay.com/',
        'zh-cn': 'https://h5.qingcigame.com/',
        'zh-tw': 'https://h5.snell.com.tw/'
      },
      language: 'zh-cn',
      animatedText: '',
      isCopying: false,
      isPlayMusic: true,
      rewardShow: false,
      mini: false,
      criminalData: [],
      criminalData1: [],
      criminalData2: [],
      clickInfo: false,
      overseasVisible: false,
      isHandClick: true,
      isFingerClick: false,
      musicObj: {
        btn: null,
        figger: null,
        frog: null,
        hammer: null,
        page: null,
        post: null,
        sweating: null,
        trial: null,
        tv: null,
        wind: null,
        more: null,
        mini: null,
        keywords: null
      },
      audioMap: {
        btn: require('@/assets/images/active/snail/fifth/mp3/btn.mp3'),
        figger: require('@/assets/images/active/snail/fifth/mp3/figger.mp3'),
        frog: require('@/assets/images/active/snail/fifth/mp3/frog.mp3'),
        hammer: require('@/assets/images/active/snail/fifth/mp3/hammer.mp3'),
        page: require('@/assets/images/active/snail/fifth/mp3/page.mp3'),
        post: require('@/assets/images/active/snail/fifth/mp3/post.mp3'),
        sweating: require('@/assets/images/active/snail/fifth/mp3/sweating.mp3'),
        trial: require('@/assets/images/active/snail/fifth/mp3/trial.mp3'),
        tv: require('@/assets/images/active/snail/fifth/mp3/tv.mp3'),
        wind: require('@/assets/images/active/snail/fifth/mp3/wind.mp3'),
        more: require('@/assets/images/active/snail/fifth/mp3/more.mp3'),
        mini: require('@/assets/images/active/snail/fifth/mp3/mini.mp3'),
        keywords: require('@/assets/images/active/snail/fifth/mp3/keywords.mp3')
      },
      keywordsInit: null,
      currentFooterComponent: 'Footer',
      dataLostSign: false,
      shareImgLoad: false,
      shareImgLoadShow: false,
      viewportRatio: 1,
      womanBottom: '0px',
    };
  },
  created() {
    const that = this
    function getViewportRatio(that) {
      const width = $(window).width();
      const height = $(window).height();
      const aspectRatio = Number((width / height).toFixed(3));
      const viewportWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      const getWidth = Math.min(viewportWidth, 750)
      if (aspectRatio >= 0.63) {
        that.womanBottom = 0 + 'px'
      } else if (aspectRatio >= 0.585) {
      } else if (aspectRatio >= 0.5) {
        that.womanBottom = ((getWidth / 750).toFixed(4) * 1) * ((getWidth / 750).toFixed(4) * 1) * 220 + 'px'
      } else if (aspectRatio >= 0.4) {
        that.womanBottom = ((getWidth / 750).toFixed(4) * 1) * ((getWidth / 750).toFixed(4) * 1) * 220 + 'px'
      } else {
        that.womanBottom = ((getWidth / 750).toFixed(4) * 1) * ((getWidth / 750).toFixed(4) * 1) * 220 + 'px'
      }
      if (width >= 750) {
        that.womanBottom = '4rem'
      }
      return (getWidth / 750).toFixed(4) * 1;
    }
    this.viewportRatio = getViewportRatio(that);
    window.addEventListener('resize', () => {
      this.viewportRatio = getViewportRatio(that);
      console.log('this.viewportRatio', this.viewportRatio);
    })
    this.language = this.getCurrentUrlKeyByOrigin();
    // this.language = 'zh-tw';
    this.isSetShare();
    this.headerConfig = headerConfig[this.language];
    this.gameName = this.languageUseMap[this.language].gameName;
    this.currentFooterComponent = this.languageUseMap[this.language].Footers;
    console.log('匹配到的 key 是：', this.language);
    this.trialConfig = new TrialConfig(this.language);
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    this.incrementTo100()
    if (
      this.$route.query.token
    ) {
      this.token = this.$route.query.token;
      this.secretFreeLogin();
    } else {
      const sign = 'created'
      this.getUserInfo(sign);
    }

    this.isWechatBrowser = wechatBrowser();
    if (this.isWechatBrowser) { // 在微信app下
      this.isWechatApp = true
    } else {
      // safari下底部被遮住
      if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))) {
        this.isSafari = true;
      }
    }
    // 埋点
    console.log(this.languageUseMap[this.language].gameName, this.languageUseMap[this.language].name, 'created')
    const bl = buriedLogger(this.languageUseMap[this.language].gameName, this.languageUseMap[this.language].name);
    this.logger = bl;
    this.messageImg = null
    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/snail/${this.languageUseMap[this.language].router}/enter${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };
    var userAgent = navigator.userAgent.toLowerCase();
    this.isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
    if (this.isPC) {
      this.$router.push(`pc${getRandomString()}`);
    } else {
    }
  },
  mounted() {
    this.initMusicObj(this.musicObj);
    this.musicObj.trial.play()
    this.musicObj.post.play();
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    stepShow: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue === 1) {
            this.musicObj.tv.stop();
          }

        }
      }

    },
    userInfo: {
      handler(newValue, oldValue) {
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {
            if (!newValue.account) {
              // TAG: 注销的时候
              this.reInit()
            } else {
              console.log('登录成功')
              this.getUserInfo()
            }
          }
        }

      }
    },
    isExpanded: {
      handler(newValue, oldValue) {
        if (newValue === true) {

        }
      }
    }
  },
  beforeDestroy() {
  },
  methods: {
    updateVisible() {
      this.overseasVisible = false
    },
    isLogin() {
      if (!this.isUserInfo) {
        console.log(this.trialConfig.translations.isLogin)
        if (this.language === 'zh-cn') {
          this.changeLoginPopup(true)
        } else {
          this.ridLogin()
        }
        return false
      }
      return true
    },
    ridLogin() {
      console.log('ridLogin')
      this.overseasVisible = true
    },
    initMusicObj(musicObj) {
      // 需要循环播放的音频 key（白名单）
      const loopList = ['tv', 'trial', 'post'];
      Object.keys(musicObj).forEach((key) => {
        musicObj[key] = new Howl({
          src: [this.audioMap[key]],
          preload: true,
          loop: loopList.includes(key) // 判断当前音频是否需要循环
        });
      });
    },
    formatDate(timestamp) {
      const date = new Date(timestamp * 1000);
      const year = String(date.getFullYear()); // 取后两位
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    reward_click() {
      this.rewardShow = false
      this.shareShow = true
      this.logger.sum('最强蜗牛_五周年报告_查看判决结果选项');
    },
    musicEvent() {
      this.isPlayMusic = !this.isPlayMusic
      const that = this
      function muteAllSounds(isMute = true) {
        Object.keys(that.musicObj).forEach(key => {
          const sound = that.musicObj[key];
          if (sound && typeof sound.mute === 'function') {
            sound.mute(isMute);
          }
        });
      }
      muteAllSounds(!this.isPlayMusic)
      this.logger.sum('最强蜗牛_五周年报告_声量');
    },

    criminalClick() {
      if (this.isCriminal) {
        return
      }
      let criminalMax = 0
      if (this.criminalData1.length > 0) {
        criminalMax = 1;
      }
      if (this.criminalData2.length > 0) {
        criminalMax = 2;
      }
      if (this.criminal < criminalMax) {
        this.criminal = this.criminal + 1
        this.isCriminal = true
        setTimeout(() => {
          this.isCriminal = false
        }, 1500)
      } else {
        this.criminalShow = false
        setTimeout(() => {
          this.isHandClick = true
          this.stepShow = 8
          setTimeout(() => {
            this.isHandClick = false
          }, 1000)
        }, 500)
      }
      console.log(this.criminal, 'this.criminal');
      this.musicObj.btn.play()
    },
    async typewriterEffect(text, interval = 100) {
      this.animatedText = ''; // 先清空
      let result = '';
      for (let i = 0; i < text.length; i++) {
        await new Promise(resolve => setTimeout(resolve, interval));
        result += text[i];
        this.animatedText = result;  // 数据绑定刷新视图
      }
      return result;
    },
    // 调用方法
    async startTyping() {
      await this.typewriterEffect(this.displayText, 100);
      // 你可以在这里继续做后续逻辑，如提示、跳转等
    },
    getCurrentUrlKeyByOrigin() {
      const currentOrigin = window.location.origin;
      const entries = Object.entries(this.URLS);
      for (let [key, fullUrl] of entries) {
        const urlOrigin = new URL(fullUrl).origin; // 提取 URLS 中每个值的 origin
        if (currentOrigin === urlOrigin) {
          return key;
        }
      }
      return 'zh-cn'; // 未匹配到时返回 zh
    },
    toggleVisibility(flagRef, duration = 2000) {
      this[flagRef] = false;
      setTimeout(() => {
        this[flagRef] = true;
      }, duration);
    },
    evidenceClick() {
      if (this.isEvidence) {
        return
      }
      if (this.evidence === 3) {
        this.evidenceShow = false
        this.isHandClick = true
        setTimeout(() => {
          this.isHandClick = false
        }, 500)
        this.stepShow = 6
      } else {
        this.isEvidence = true
        this.evidence = this.evidence + 1
        setTimeout(() => {
          this.isEvidence = false
        }, 1000)
      }
      this.musicObj.btn.play()
      console.log(this.evidence, 'this.evidence');
    },
    answerClick(info) {
      const that = this
      clearInterval(that.keywordsInit)
      this.musicObj.keywords.stop()
      this.musicObj.figger.play()
      if (this.stepShow === 4) {
        setTimeout(() => {
          this.dialogueShow = false
          this.answerShow = false
          this.isHandClick = true
          setTimeout(() => {
            this.isHandClick = false
          }, 500)
          if (info.display === '6,8') {
            this.logger.sum('最强蜗牛_五周年报告_自行辩护选项');
          } else {
            this.logger.sum('最强蜗牛_五周年报告_申请律师辩护选项');
          }
          setTimeout(() => {
            this.stepShow = 5
            this.toggleVisibility('msgActive', 3000)
          }, 1000)
        }, 300)
      }
      if (that.stepShow === 6) {
        if (info.display === '13') {
          this.clickInfo = true
          this.logger.sum('最强蜗牛_五周年报告_不抗辩选项');
        } else {
          this.logger.sum('最强蜗牛_五周年报告_抗辩选项');
          this.clickInfo = false
        }
        setTimeout(() => {
          that.dialogueShow = false
          this.isHandClick = true
          setTimeout(() => {
            this.isHandClick = false
          }, 500)
          that.stepShow = 7
        }, 300)
      }
      this.dynamicsConfig.updateMsglist(info.display)
      this.$set(this.dynamicsConfig, 'msglist', this.dynamicsConfig.msglist)
      if (that.stepShow !== 4 || that.stepShow !== 6) {
        this.logger.sum('最强蜗牛_五周年报告_回答问题失败');
        this.dialogueShow = false
      }
    },
    fingerClick() {
      if (this.isFingerClick) {
        return
      }
      this.isFingerClick = true
      this.logger.sum('最强蜗牛_五周年报告_按手印');
      this.fingerShow = true
      this.musicObj.figger.play()
      const that = this
      setTimeout(() => {
        this.dialogueShow = true

        setTimeout(() => {
          if (!that.keywordsInit) {
            that.keywordsInit = setInterval(() => {
              that.musicObj.keywords.play()
            }, 120)
          }
        }, 100)
        setTimeout(() => {
          that.answerShow = true
          clearInterval(that.keywordsInit)
        }, 2000)
        that.envelopeShow = false
        console.log('that.fingerClick', that.stepShow);
      }, 2000)

    },
    openEnvelope() {
      this.logger.sum('最强蜗牛_五周年报告_核对信息');
      this.envelopeShow_min = true
      this.musicObj.wind.play()
      setTimeout(() => {
        this.isFingerClick = false
      }, 1500)
    },
    handClick() {
      const that = this
      if (this.isHandClick) {
        return
      }
      that.isHandClick = true
      setTimeout(() => {
        that.isHandClick = false
      }, 1000)
      this.musicObj.btn.play()
      if (this.userInfo.score < 100000) {
        this.mini = true
        if (this.stepShow === 5) {
          // 礼包
          if (!that.userInfo.reward_get) {
            this.reward()
            this.rewardShow = true
          } else {
            this.shareShow = true
          }
          return
        }
        this.stepShow = this.stepShow + 1
        return
      }
      if (this.stepShow === 11) {
        that.animationLastShow = true
        that.musicObj.hammer.play()
        setTimeout(() => {
          that.musicObj.hammer.play()
          setTimeout(() => {
            that.musicObj.hammer.play()
          }, 666)
        }, 666)
        setTimeout(() => {
          setTimeout(() => {
            if (!that.userInfo.reward_get) {
              that.reward()
              that.rewardShow = true
              that.animationLastShow = false
            } else {
              that.shareShow = true
              that.animationLastShow = false
            }
            setTimeout(() => {
              that.musicObj.wind.play()
            }, 500)
          }, 1000)
        }, 4500)
      }
      if (this.stepShow === 7) {
        if (this.dataLostSign) return
        this.criminalShow = true
        return
      }
      if (this.stepShow === 6) {

        // 存在数据丢失标志，直接判决。
        if (this.dataLostSign) {
          this.animationLastShow = true
          setTimeout(() => {
            this.musicObj.hammer = true
          }, 300)
          setTimeout(() => {
            setTimeout(() => {
              if (!this.userInfo.reward_get) {
                this.reward()
                this.rewardShow = true
                this.animationLastShow = false
              } else {
                this.shareShow = true
                this.animationLastShow = false
              }
              setTimeout(() => {
                this.musicObj.wind.play()
              }, 500)
            }, 1000)
          }, 4500)
          return
        }
        this.questionInfo = this.dynamicsConfig.getQuestionContent(2)
        this.questionInfo.question = this.questionInfo.question[0].split('，')
        this.questionInfo.question[0] = this.questionInfo.question[0] + ','
        this.questionInfo = this.questionInfo
        this.dialogueShow = true
        setTimeout(() => {
          if (!this.keywordsInit) {
            that.keywordsInit = setInterval(() => {
              this.musicObj.keywords.play()
            }, 150)
          }
        }, 100)
        setTimeout(() => {
          this.answerShow = true
          clearInterval(that.keywordsInit)
        }, 4000)
        return
      }
      if (this.stepShow === 5) {
        that.evidenceShow = true
        return
      }
      if (this.stepShow === 3) {
        this.stepShow = this.stepShow + 1
        this.envelopeShow = true
        this.isFingerClick = true
        this.musicObj.wind.play()
        console.log(this.stepShow, 'this.stepShow');
        return
      }

      if (this.stepShow === 4) {
      }
      this.stepShow = this.stepShow + 1
      console.log(this.stepShow, 'this.stepShow');
      this.toggleVisibility('msgActive', 2000)
    },
    watchTv() {
      const that = this
      // ✅ 很抱歉，请先登录
      if (!this.isLogin()) {
        return
      }
      // ✅ 很抱歉，请先选择角色
      if (!this.newUserInfo.role_name) {
        this.changeOsPopup(true);
        return this.onToast(this.trialConfig.translations.isRole);
      }
      that.musicObj.tv.stop()
      that.overlayClass = true
      setTimeout(() => {
        that.musicObj.mini.play()
        setTimeout(() => {
          that.musicObj.more.play()
        }, 1800)
      }, 300)
      setTimeout(() => {
        that.stepShow = 1
      }, 1500)
      setTimeout(() => {
        that.overlayClass = false
        setTimeout(() => {
          that.animationShow = true
          setTimeout(() => {
            that.musicObj.frog.play()
            setTimeout(() => {
              that.musicObj.sweating.play()
              setTimeout(() => {
                that.musicObj.hammer.play()
                setTimeout(() => {
                  that.musicObj.hammer.play()
                  setTimeout(() => {
                    that.musicObj.hammer.play()
                  }, 666)
                }, 666)
              }, 2000)
            }, 2000)
          }, 500)
          setTimeout(() => {
            that.animationShow = false
            that.isHandClick = false
          }, 6000)
        }, 500)
      }, 3500)
    },
    // 免密登录请求
    secretFreeLogin() {
      let params = {
        token: this.token
      };
      secretFreeLoginApi(params).then(response => {
        if (response.code == 200) {
          localStorage.setItem('access_token', response.data.access_token);
          let newQuery = JSON.parse(JSON.stringify(this.$route.query))
          delete newQuery.token
          // 可以值替换参数，不改变路由
          this.$router.replace({
            query: newQuery,
          })

          this.logger.sum("最强蜗牛_五周年报告_免密登录成功");
        } else {
          this.logger.sum("最强蜗牛_五周年报告_免密登录失败");
          this.onToast(response.message);
        }
      }).finally(() => {
        this.getUserInfo();
      }).catch((err) => {
        this.onToast(err)
      })
    },
    incrementTo100() {
      const target = 100;
      const duration = 2700; // 持续时间1秒
      const stepTime = duration / target; // 每一步的时间间隔
      const that = this
      const intervalId = setInterval(() => {
        that.count += 1;
        if (that.count >= target) {
          clearInterval(intervalId); // 当达到100时停止计时器   
          that.musicObj.post.stop()
          that.musicObj.tv.play()
        }
      }, stepTime);
    },
    async reward() {
      const token = localStorage.getItem("access_token");
      const params = {
        access_token: token || null,
      }
      reward(params).then(res => {
        this.logger.sum('最强蜗牛_五周年报告_领取奖励');
        if (res.code === 200) {
          // this.priceShow = true
          this.getUserInfo()
        } else {
          this.onToast(res.message)
        }
      }).finally(() => {
      })

    },
    throttle(func, delay) {
      let lastTime = 0;
      return function (...args) {
        const now = Date.now();
        if (now - lastTime >= delay) {
          lastTime = now;
          return func.apply(this, args);
        }
      };
    },
    async onShare(my_id) {
      this.shareShow = true
      // ✅ 1秒内禁用，节流功能
      if (this.isCopying) return;
      if (!this.shareImg) {
        await this.generateShareImage();
      }
      this.isCopying = true; // 设置节流标志
      setTimeout(() => {
        this.isCopying = false;
      }, 2000); // 节流时间设置为1秒

      // ✅ 以下为原始复制逻辑

      if (!this.isLogin()) {
        return
      }
      this.logger.sum('最强蜗牛_五周年_分享按钮');
      this.shareImgLoadShow = true
      this.onCopy(my_id);
    },
    onCopy(my_id) {
      this.logger.sum('最强蜗牛_五周年_复制链接邀请好友');
      const clipboard = new Clipboard(my_id);
      clipboard.on("success", (e) => {
        this.onToast(this.trialConfig.translations.copySuccess, 2000);
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.onToast(this.trialConfig.translations.copyError, 2000);
      });
    },
    downloadLocalImage() {
      const localImgUrl = this.shareImg; // 注意：public 目录下相对路径
      const link = document.createElement('a');
      link.href = localImgUrl;
      link.download = `${this.languageUseMap[this.language].router}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    initShareData() {
      try {
        const { protocol, host } = window.location;
        this.shareLink = `${protocol}//${host}/snail/${this.languageUseMap[this.language].router}/enter${getRandomString()}`;
        this.$set(this, 'shareLink', this.shareLink)
        console.log(this.shareLink, 'shareLink')
        this.isSetShare(this.shareLink);
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    qrcode(link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
      generateQRCode(document.getElementById('qrcode1'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
    },
    // 分享图片设置
    async generateShareImage() {
      Indicator.open();
      await generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          this.preventShow = false;
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
          Indicator.close();
        })
        .catch((err) => {
          this.preventShow = false;
          Indicator.close();
          console.log('err: 图片生成失败', err.message);
        });
    },
    // 获取用户信息
    getUserInfo(sign) {
      const token = localStorage.getItem("access_token");
      const that = this
      const params = {
        access_token: token || null,
      }
      function processData(data) {
        // 如果数据超过6个，随机取6个
        if (data.length > 6) {
          data = data.sort(() => Math.random() - 0.5).slice(0, 6);
        }

        // 如果数据长度是奇数，去掉最后一个，确保能两两分组
        if (data.length % 2 !== 0) {
          data = data.slice(0, data.length - 1);
        }

        // 两两分组
        const result = [];
        for (let i = 0; i < data.length; i += 2) {
          result.push(data.slice(i, i + 2));
        }

        return result;
      }
      onGetInitDataAPI(params).then(response => {
        if (response.code === 200) {
          that.activity = response.data.activity
          that.isUserInfo = true
          if (response.data.userinfo.account === null) {
            response.data.userinfo.account = response.data.userinfo.rid
          }
          const activeUserInfo = {
            account: response.data.userinfo.account,
            channel: response.data.userinfo.channel,
            game_id: response.data.userinfo.game_id,
            reward_get: response.data.userinfo.reward_get,
            rid: response.data.userinfo.rid,
            role_name: response.data.userinfo.role_name,
            server_id: response.data.userinfo.server_id,
            server_name: response.data.userinfo.server_name,
          }
          // 是否有没触发的彩蛋
          if (response.data.activity.hasOwnProperty('untriggered_egg_18')) {
            if (response.data.activity.untriggered_egg_18 !== 0) {
              const obj = {
                "id": 1,
                "role_id": null,
                "platform": "gz",
                "type": 14,
                "total_amount": response.data.activity.total_score,
                "time": "2020-05-07",
                "created_at": "2025-06-13 19:44:41",
                "updated_at": "2025-06-13 19:44:41"
              }
              response.data.userinfo.other_data.data14 = obj
            }
          }
          if (response.data.activity.hasOwnProperty('untriggered_egg_1000')) {
            if (response.data.activity.untriggered_egg_18 !== 0) {
              const obj = {
                "id": 1,
                "role_id": null,
                "platform": "gz",
                "type": 14,
                "total_amount": response.data.activity.total_score,
                "time": "2020-05-07",
                "created_at": "2025-06-13 19:44:41",
                "updated_at": "2025-06-13 19:44:41"
              }
              response.data.userinfo.other_data.data15 = obj
            }
          }
          that.onInitState(response);
          that.initShareData();
          that.isSetShare();
          that.shareImgLoad = true;
          that.userinfo = response.data.userinfo;
          that.newUserInfo = activeUserInfo
          if (that.activity.total_score < 100000) {
            that.shareBg = that.trialConfig.translations.wantedLow
            that.eventBg = that.trialConfig.translations.eventLow
          } else {
            that.shareBg = that.trialConfig.translations.wanted
            that.eventBg = that.trialConfig.translations.event
          }
          const validValues = Object.values(response.data.userinfo.other_data).filter(item => {
            return item && typeof item === 'object' && Object.keys(item).length > 0;
          });
          response.data.activity.dataLostSign = false
          if (validValues.length < 2) {
            that.dataLostSign = true
            response.data.activity.dataLostSign = true
          }
          console.log(that.newUserInfo, '获取用户信息成功');
          const dynamicsConfigParams = Object.assign({}, response.data.activity, response.data.userinfo)
          that.dynamicsConfig = new dynamicsConfig(that.language, dynamicsConfigParams)
          const processList = processData(Object.values(that.dynamicsConfig.dynamicsContentDetails.otherData))
          that.criminalData = processList[0]
          if (processList.length > 1) {
            that.criminalData1 = processList[1]
          }
          if (processList.length > 2) {
            that.criminalData2 = processList[2]
          }
          console.log(that.criminalData, 'that.criminalData');
          console.log(that.criminalData1, 'that.criminalData1');
          that.dynamicsConfig.msglist = that.dynamicsConfig.msglist
          if (that.dataLostSign) {
            that.dynamicsConfig.updateMsglist('10,11,12,13,14,15,16,17')
            that.dynamicsConfig.msglist = that.dynamicsConfig.msglist
          }
          that.questionInfo = that.dynamicsConfig.getQuestionContent(1)

        } else {
          that.isUserInfo = false
          //初始化未登录不提示
          if (sign !== 'created') {
            that.onToast(response.message);
          }
          that.setInitUserInfo();
          that.setInitActiveInfo();
        }
      }).catch(() => {
      }).finally(() => {
      })
    },
    onInitState(response) {
      const { code } = response || {}
      if (response.code == 200) {
        console.log('初始化数据成功');

        this.setUserInfo(response.data.userinfo);
      }
      // 很抱歉，请先登录！
      if (response.code == 403) {
        if (!this.isLogin()) {
          return
        }
      }
    },
    anginClick() {
      Indicator.open();
      this.musicObj.tv.play()
      this.stepShow = 0
      this.criminal = 0
      this.evidence = 0
      this.fingerShow = false
      this.answerShow = false
      this.envelopeShow_min = false
      this.isFingerClick = false
      clearInterval(this.keywordsInit)
      this.logger.sum('最强蜗牛_五周年报告_再看一次按钮');
      setTimeout(() => {
        Indicator.close();
        this.shareShow = false
      }, 1000)
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.isUserInfo = false; // 是否获取到用户信息，用于判断是否显示登录弹窗等
      this.shareImg = StringNullableChain
      this.activity = {
        race: 1
      },
        this.answerShow = false
      this.isFingerClick = false
      this.changeOsPopup(false)
      this.newUserInfo = {}
      this.setInitUserInfo();
      this.setInitActiveInfo();
      this.stepShow = 0
      this.criminal = 0
      this.evidence = 0
      clearInterval(this.keywordsInit)
      console.log('注销')
    },
    LoginCallBack() {
    },
    // 选择角色后
    selectCallback() {
      this.stepShow = 0

      this.stepShow = 0
      this.criminal = 0
      this.evidence = 0
      // 初始化
      this.getUserInfo();
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo
      selectInfo.account = this.userInfo.account
      this.setUserInfo(selectInfo);
      console.log(this.selectInfo, '选择角色信息')
      this.newUserInfo = JSON.parse(JSON.stringify(this.selectInfo))
    },
    reInit() {
      console.log('清除data里面相关数据')
      this.clearActiveInfo(); // 清除data里面相关数据
      this.changeOsPopup(false)
    },
    onCopyShare(my_id) {
      this.isWechatBrowser = wechatBrowser();
      if (this.isWechatBrowser) { // 在微信app下
        console.log('在微信app下');
        this.logger.sum('最强蜗牛_五周年报告_微信内分享');
        return this.wxLoadShow = true
      } else {
        this.onCopy(my_id)
      }
    },
    // 区组弹窗注销-相关参数复位
    osCancell() { },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },

    // TAG: 其他简易封装的方法
    openPopup(name) {
      const that = this
      if (name === 'benefit') {
        this.logger.sum('最强蜗牛_五周年_福利按钮');
        window.location.href = this.trialConfig.translations.benefitLink
        return
      }
      if (name === 'ruleShow') {
        this.logger.sum('最强蜗牛_五周年_活动说明');
      }
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;
    },
    // 微信分享
    isSetShare() {
      const { protocol, host } = window.location;
      this.setShare({
        link: `${protocol}//${host}/snail/${this.languageUseMap[this.language].router}/enter${getRandomString()}`,
        title: '最强蜗牛：年度审判',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/ZnD5qB2deshbTdSvoXHrMjUdtOFNzYcTIQUyX7FO.jpeg',
        desc: '盘点蜗犯的罪，领取改造的礼'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
<style lang="less">
.fifth-snail-tvShow-captions-text {
  font-family: SourceHanSansCNBlod;
  font-weight: bold;
  font-size: 44px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  animation: marquee 30s linear infinite;
  position: absolute;
  bottom: 10px;
  padding-left: 30%;
  white-space: nowrap;

  /* 初始位置在右侧 */
  span {
    position: relative;
    display: inline-block;
  }

  span::after {
    content: '';
    position: absolute;
    left: 0;
    top: 45%;
    /* 调整线条垂直位置 */
    width: 100%;
    height: 5px;
    /* 线条粗细 */
    background: #f00;
    /* 线条颜色 */
    transform: rotate(-19deg);
    /* 调整倾斜角度 */
    opacity: 0.8;
    /* 线条透明度 */
  }

  @keyframes marquee {
    0% {
      transform: translateX(5%);
    }

    100% {
      transform: translateX(-100%);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/snail/5thReport/index/index.vue